/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import FilterHistoryPayload from './FilterHistoryPayload';

/**
 * The FilterHistory model module.
 * @module model/FilterHistory
 * @version 1.0.0
 */
class FilterHistory {
    /**
     * Constructs a new <code>FilterHistory</code>.
     * @alias module:model/FilterHistory
     */
    constructor() { 
        
        FilterHistory.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>FilterHistory</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FilterHistory} obj Optional instance to populate.
     * @return {module:model/FilterHistory} The populated <code>FilterHistory</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FilterHistory();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('agent_id')) {
                obj['agent_id'] = ApiClient.convertToType(data['agent_id'], 'Number');
            }
            if (data.hasOwnProperty('screen_key')) {
                obj['screen_key'] = ApiClient.convertToType(data['screen_key'], 'String');
            }
            if (data.hasOwnProperty('screen_label')) {
                obj['screen_label'] = ApiClient.convertToType(data['screen_label'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('is_named')) {
                obj['is_named'] = ApiClient.convertToType(data['is_named'], 'Boolean');
            }
            if (data.hasOwnProperty('payload')) {
                obj['payload'] = FilterHistoryPayload.constructFromObject(data['payload']);
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>FilterHistory</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FilterHistory</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
            throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
        }
        // ensure the json data is a string
        if (data['screen_key'] && !(typeof data['screen_key'] === 'string' || data['screen_key'] instanceof String)) {
            throw new Error("Expected the field `screen_key` to be a primitive type in the JSON string but got " + data['screen_key']);
        }
        // ensure the json data is a string
        if (data['screen_label'] && !(typeof data['screen_label'] === 'string' || data['screen_label'] instanceof String)) {
            throw new Error("Expected the field `screen_label` to be a primitive type in the JSON string but got " + data['screen_label']);
        }
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // validate the optional field `payload`
        if (data['payload']) { // data not null
          FilterHistoryPayload.validateJSON(data['payload']);
        }

        return true;
    }


}



/**
 * @member {String} id
 */
FilterHistory.prototype['id'] = undefined;

/**
 * @member {Number} agent_id
 */
FilterHistory.prototype['agent_id'] = undefined;

/**
 * @member {String} screen_key
 */
FilterHistory.prototype['screen_key'] = undefined;

/**
 * @member {String} screen_label
 */
FilterHistory.prototype['screen_label'] = undefined;

/**
 * @member {String} title
 */
FilterHistory.prototype['title'] = undefined;

/**
 * @member {Boolean} is_named
 */
FilterHistory.prototype['is_named'] = undefined;

/**
 * @member {module:model/FilterHistoryPayload} payload
 */
FilterHistory.prototype['payload'] = undefined;

/**
 * @member {Date} created_at
 */
FilterHistory.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
FilterHistory.prototype['updated_at'] = undefined;






export default FilterHistory;

